//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MSection from './m_section.vue'

export default {
  extends: MSection,
  watch: {
    '$route.params.section': '$fetch'
  }
}
